import { describirErrorSubida as describirErrorSubidaComun } from "../../../helpers/mensajeErrorSubida";
// D8.14.2 — Helpers puros de NodeConfigModal.

export const buildMediaUrl = (url) => {
  if (!url) return null;
  if (
    url.startsWith("blob:") ||
    url.startsWith("http://") ||
    url.startsWith("https://")
  ) {
    return url;
  }
  const backend =
    window.WATOOLX_BACKEND_URL || process.env.REACT_APP_BACKEND_URL || window.location.origin;
  return `${backend}${url.startsWith("/") ? url : `/${url}`}`;
};

/**
 * Parsea de forma segura el array de ítems de un content node.
 * Acepta tanto Array como JSON string (por si el backend devuelve string).
 */
export const safeParseItems = (raw) => {
  if (Array.isArray(raw)) return raw;
  if (typeof raw === "string" && raw.trim().startsWith("[")) {
    try {
      return JSON.parse(raw);
    } catch {
      return [];
    }
  }
  return [];
};

// ─────────────────────────────────────────────────────────────────────────────

/** Límites de WhatsApp, los mismos que valida el backend (config/uploadFlowBuilder). */
const LIMITE_MB = { image: 5, video: 16, audio: 16, document: 100 };

const familiaDe = (mime = "") =>
  mime.startsWith("image/") ? "image" : mime.startsWith("video/") ? "video" : mime.startsWith("audio/") ? "audio" : "document";

/**
 * Comprueba el archivo ANTES de subirlo (QA 0422). Devuelve el motivo del rechazo o null.
 * Así un vídeo de 20 MB no viaja entero al servidor para que lo rechace.
 */
export const validarAntesDeSubir = (file) => {
  if (!file) return "No se seleccionó ningún archivo";
  const familia = familiaDe(file.type || "");
  const mb = file.size / (1024 * 1024);
  if (mb > LIMITE_MB[familia]) {
    const nombre = { image: "La imagen", video: "El vídeo", audio: "El audio", document: "El documento" }[familia];
    return `${nombre} pesa ${mb.toFixed(1)} MB y WhatsApp admite hasta ${LIMITE_MB[familia]} MB`;
  }
  if (/heic|heif/i.test(`${file.type} ${file.name}`)) {
    return "Las fotos HEIC (formato de iPhone) no se pueden enviar por WhatsApp: guárdala como JPG o PNG";
  }
  return null;
};

/**
 * Traduce un fallo de subida a un motivo que el usuario pueda entender (QA 0422). Antes todo
 * era «Error al subir archivo»: un límite del proxy (nginx responde 413 en HTML, sin JSON), un
 * tipo rechazado o una caída de red eran indistinguibles — para el usuario y para soporte.
 */
// Mismo criterio en toda la app (FlowBuilder, listas de archivos…): ver helpers/mensajeErrorSubida.
export const describirErrorSubida = (error, file) => describirErrorSubidaComun(error, file);
